import type { ReportDefinitionSendOutcome } from './api';

type Status = ReportDefinitionSendOutcome['status'];
type FailureOrigin = NonNullable<ReportDefinitionSendOutcome['failureOrigin']>;
type Tone = 'success' | 'warning' | 'info' | 'danger';

/** O selo de um canal num envio, igual na gaveta e na tela de envios. A falha do WhatsApp diz onde aconteceu. */
export class ReportSendBadge {
  private static readonly SHOWN: Record<Status, { label: string; tone: Tone }> = {
    read: { label: 'Lido', tone: 'success' },
    opened: { label: 'Aberto', tone: 'success' },
    delivered: { label: 'Entregue', tone: 'success' },
    delayed: { label: 'Atrasado', tone: 'warning' },
    sent: { label: 'Enviado', tone: 'info' },
    failed: { label: 'Falhou', tone: 'danger' },
  };

  private static readonly FAILED_AT: Record<FailureOrigin, string> = {
    meta: 'Falhou · Meta',
    send: 'Falhou · Na hora do envio',
  };

  static of({ status, failureOrigin }: Pick<ReportDefinitionSendOutcome, 'status' | 'failureOrigin'>): { label: string; tone: Tone } {
    const shown = ReportSendBadge.SHOWN[status];
    if (!failureOrigin) return shown;
    return { ...shown, label: ReportSendBadge.FAILED_AT[failureOrigin] };
  }
}
